export default "__VITE_ASSET__Cfi0vngJ__"